export enum WithOption {
  EXTRA_QUESTIONNAIRES = 'extra_questionnaires',
  RENEWAL_PRICES = 'renewal_prices',
  ALLOW_PARTIAL_SUCCESS = 'allow_partial_success',
}
